<div id="principal" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h1 class="title">Principal's Message</h1>
    <div class="inner-lead mt-4">
      <div class="row align-items-start g-4">
        <div class="col-md-4 text-center">
          <!-- Principal photo: assets/images/admin/principal.jpg -->
          <img src="/assets/img/message/principal.jpg" alt="Dr. Geeta Monga, Principal" class="img-fluid rounded shadow"
            style="max-width:280px;">
          <div class="mt-3">
            <h5 class="fw-bold mb-0">Dr. Geeta Monga</h5>
            <p class="text-muted">Principal<br>Shah Satnam Ji Girls' College, Sirsa</p>
          </div>
        </div>
        <div class="col-md-8">
          <p>Warm greetings to all!</p>
          <p>Shah Satnam Ji Girls' College is not merely an institution; it's a vibrant tapestry woven with threads of
            academic excellence, holistic development and spiritual awakening. Here, we believe in nurturing young
            women who are not just intellectually sound, but also strong in character, compassionate towards society and
            empowered to chase their dreams.</p>
          <p>Here education extends beyond textbooks. We foster a love for learning through a multitude of activities —
            from sports that ignite a spirit of healthy competition to cultural events that celebrate the richness of
            our heritage. Co-curricular activities provide a platform for students to discover hidden talents, develop
            leadership skills and become well-rounded individuals.</p>
          <p>At the core of our philosophy lies an emphasis on spiritual and moral values i.e. Gurukul Sanskaras which
            is
            the dire need of the society. We draw inspiration from teachings of Saint Dr Gurmeet Ram Rahim Singh Ji
            Insan
            fostering a sense of compassion, integrity and service to humanity. This spiritual foundation equips our
            students to navigate the complexities of life with grace and purpose.</p>
          <p>Our college boasts a history of outstanding achievements. Our students consistently excel in academics,
            sports and cultural activities bringing immense pride to our institution. But more importantly, we celebrate
            the success stories of young women who leave our portals, empowered to make a positive impact on the world.
          </p>
          <p>If you are seeking an education that transcends boundaries, an environment that nurtures both mind and
            soul, then Shah Satnam Ji Girls' College is your destination. We invite you to embark on a transformative
            journey of learning, growth and self-discovery.</p>
          <p class="fst-italic">"Be the change you wish to see in the world."</p>
          <div class="mt-3">
            <p class="fw-bold mb-0">With Warm Regards,</p>
            <p class="mb-0">Dr. Geeta Monga</p>
            <p class="mb-0">Principal</p>
            <p class="text-muted">Shah Satnam Ji Girls' College, Sirsa</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>